'use es6';

import { useSelector } from 'react-redux';
import { getHubspotUtk } from '../../query-params/hubspotUtk';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
export const withHubspotUtk = WrappedComponent => props => {
  const hubspotUtk = useSelector(getHubspotUtk);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    hubspotUtk: hubspotUtk
  }));
};